export class AvverkningsanmalanStatus {
// eslint-disable-next-line sonarjs/public-static-readonly
    static ny = "Ny";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static skickad = "Skickad";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static registrerad = "Registrerad";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static kompletteringKravs = "Komplettering krävs";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static avslag = "Avslag";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static aterkallad = "Återkallad";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static borttagen = "Borttagen";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static kompletteringNy = "Komplettering Ny";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static kompletteringSkickad = "Komplettering Skickad";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static registreradManuellt = "Registrerad manuellt";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static all = [
        AvverkningsanmalanStatus.ny,
        AvverkningsanmalanStatus.skickad,
        AvverkningsanmalanStatus.registrerad,
        AvverkningsanmalanStatus.kompletteringKravs,
        AvverkningsanmalanStatus.kompletteringNy,
        AvverkningsanmalanStatus.kompletteringSkickad,
        AvverkningsanmalanStatus.registreradManuellt,
        AvverkningsanmalanStatus.avslag,
        AvverkningsanmalanStatus.aterkallad,
        AvverkningsanmalanStatus.borttagen
    ];
}
